<template>
  <EcsAgentWallboardInformation />
</template>

<script>
import { mapGetters } from 'vuex';
import EcsAgentWallboardInformation from '@/components/ecs-wallboard-information/EcsWallboardInformation';

export default {
  name: 'EcsSupervisorPage',

  components: { EcsAgentWallboardInformation },

  computed: {
    ...mapGetters('AGENT', ['isSupervisor']),
    ...mapGetters('DASHBOARD', ['selectedSupervisorDashboardComponent'])
  }
};
</script>

<style scoped>
.supervisor-page-container {
  height: 100%;
  width: 100%;
}
</style>
